import { BrandEnum, TestTypeEnum } from "../dtos/enum";

export class NavigationRoute {
  public static LOGIN_PAGE = "/login";
  public static REGISTRATION = {
    testSelection: "test-selection",
    testSelectionWebDelivery: "test-selection-web-delivery",
    sittingSelection: "sitting-selection",
    sittingSelectionWebDelivery: "sitting-selection-web-delivery",
    accountSelection: "select-accounts",
    proofOfIdentity: "proof-of-identity",
    biometricConsent: "biometric-consent",
    photoUpload: "photo-upload",
    scannedDocumentUpload: "scanned-document-upload",
    scoreReport: "score-report",
    testSummary: "test-summary",
    studyMaterials: "study-materials",
    orderSummary: "order-summary",
    orderComplete: "order-complete",
  };
}

export class CheckoutStepsRoute {
  public static CHECKOUT = {
    adress: "checkout/address",
    shipping: "checkout/shipping",
    reviewAndPayment: "checkout/review",
    Completed: "checkout/done",
  };
}

export class ExternalUrl {
  public static WORD_PRESS_MAP: Map<BrandEnum, string> = new Map([
    [BrandEnum.CELPIP, "https://www.celpip.ca/take-celpip/find-a-test-date/"],
    [BrandEnum.CAEL, "https://www.cael.ca/take-cael/find-a-test-date/"],
  ]);
}

export class CssStyle {
  public static TEST_TYPE_MAP: Map<TestTypeEnum, string> = new Map([
    [TestTypeEnum.CELPIP_G, "g"],
    [TestTypeEnum.CELPIP_LS, "ls"],
    [TestTypeEnum.CELPIP_SAFT, "g"],
    [TestTypeEnum.RESEARCH_G, "g"],
  ]);
}

export class LogoUrl {
  public static LOGO_URL_MAP: Map<string, string> = new Map([
    ["CELPIP_GENERAL_LOGO", "logo-celpip-g.png"],
    ["CELPIP_LS_LOGO", "logo-celpip-ls.png"],
    ["CELPIP_PRETEST_LOGO", "logo-celpip-pretest.png"],
    ["CAEL_CE_LOGO", "logo-cael-ce.png"],
    ["CAEL_PRETEST_LOGO", "logo-cael-pretest.png"],
  ]);
}

export const PHOTO_OVERLAY = "photo-overlay.png";

export const SEE_INSIDE_ICONE_URL = "see-inside.png";
